module.exports = __webpack_public_path__ + "img/nantes-logo-icon.823f7744.png";